/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import type * as Types from '@sg/graphql-schema';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequestAccountDeletionMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type RequestAccountDeletionMutation = {
  readonly __typename?: 'Mutation';
  readonly requestAccountDeletion:
    | { readonly __typename?: 'RequestAccountDeletionFailed' }
    | {
        readonly __typename: 'RequestAccountDeletionSuccess';
        readonly success: boolean;
      }
    | null;
};

export const RequestAccountDeletionDocument = gql`
  mutation RequestAccountDeletion {
    requestAccountDeletion {
      ... on RequestAccountDeletionSuccess {
        success
        __typename
      }
    }
  }
`;

export function useRequestAccountDeletionMutation() {
  return Urql.useMutation<
    RequestAccountDeletionMutation,
    RequestAccountDeletionMutationVariables
  >(RequestAccountDeletionDocument);
}
